{
  "#LLR_KOMMISSIONIERUNG": {
    "TITEL_WARENZUGANG": "Warenzugang",
    "AKTIONEN": {
      "LABEL_WARENZUGANG": "Warenzugang",
      "LABEL_WARENZUGANG_BUCHEN": "Warenzugang buchen",
      "LABEL_PALETTE_ABSCHLIESSEN": "Palette abschließen",
      "LABEL_ARTIKEL_SCANNEN": "Artikel scannen",
      "LABEL_PALETTE_SCANNEN": "Palette scannen",
      "LABEL_BESTELLUNG_SCANNEN": "Bestellung scannen",
      "LABEL_PALETTENDATEN_SCANNEN": "Palettendaten scannen",
      "LABEL_ARTIKELDATEN_SCANNEN": "Artikeldaten scannen",
      "LABEL_VORHANDENE_PALETTE_AUSWAEHLEN": "Vorhandene Palette auswählen",
      "LABEL_PALETTE_ERSTELLEN": "Neue Palette erstellen",
      "LABEL_PALETTE_AENDERN": "Palettendaten ändern",
      "LABEL_PALETTE_DRUCKEN": "Palette drucken",
      "LABEL_PALETTE_SPEICHERN": "Palette Speichern",
      "LABEL_WEITER": "Weiter",
      "LABEL_BESTELLUNGEN_ABSCHLIESSEN": "(Bestellungen abschließen)",
      "LABEL_BESTELLUNGEN_OFFEN_LASSEN": "(Bestellungen offen lassen)",
      "LABEL_FOTOS_HOCHLADEN": "Fotos hochladen"
    },
    "DIALOG_GLOBAL": {
      "LABEL_ABBRECHEN": "Abbrechen",
      "LABEL_AENDERUNGEN_SPEICHERN": "Änderungen speichern",
      "LABEL_AUSWAHL_UEBERNEHMEN": "Auswahl übernehmen",
      "LABEL_UEBERNEHMEN": "Übernehmen",
      "LABEL_FORTFAHREN": "Fortfahren",
      "LABEL_AUSWAHL_FUER_ABSCHLUSS": "Bitte auswählen, wie der Warenzugang abgeschlossen werden soll",
      "LABEL_ARTIKEL_ABGESCHLOSSEN": "Der Artikel wurde erfolgreich abgeschlossen.",
      "LABEL_WARENZUGANG_ABGEBROCHEN": "Der Warenzugang wurde abgebrochen.",
      "LABEL_BESTELLUNG_UEBERNEHMEN": "Diese Bestellung wird gerade von einem anderen Benutzer bearbeitet, möchten Sie dennoch fortfahren?",
      "TITEL_BESTELLUNG_UEBERNEHMEN": "Bestellung in Bearbeitung",
      "TITEL_KOMMISSIONIERUNG_ABSCHLIESSEN": "Warenzugang abschließen",
      "TITEL_BESTELLUNG_ABGESCHLOSSEN": "Bestellung abgeschlossen!",
      "TITEL_LIEFERSCHEIN_ABGESCHLOSSEN": "Lieferschein abgeschlossen!",
      "TITEL_ARTIKEL_ABGESCHLOSSEN": "Artikel abgeschlossen!",
      "TITEL_WARENZUGANG_ABGESCHLOSSEN": "Warenzugang abgeschlossen!",
      "TITEL_WARENZUGANG_ABGEBROCHEN": "Warenzugang abgebrochen",
      "SELECT_OPTION_BESTELLUNG_ERLEDIGT": "Bestellung abschließen",
      "SELECT_OPTION_LIEFERUNG_ERLEDIGT": "Lieferung abschließen, Bestellung bleibt offen",
      "SELECT_OPTION_ABBRECHEN": "Warenzugang Abbrechen",
      "MESSAGE_BESTELLUNG_ABGESCHLOSSEN": "Der Warenzugang und die Bestellungen wurden erfolgreich abgeschlossen.",
      "MESSAGE_LIEFERSCHEIN_ABGESCHLOSSEN": "Der Warenzugang wurde erfolgreich abgeschlossen und die Bestellungen offen gelassen."
    },
    "MESSAGES": {
      "TITEL_MENGE_ZU_GERING": "Menge zu gering!",
      "LABEL_MENGE_ZU_GERING": "Bitte eine positive Menge angeben."
    },
    "WARENZUGANG": {
      "TITEL_BESTELLUNGEN": "BESTELLUNGEN",
      "SUBTITEL_BESTELLUNGEN": "Bestellungen",
      "TITEL_BESTELLUNG_SCANNEN": "Bestellung scannen",
      "LABEL_BESTELLUNG_SCANNEN": "Bitte tippen um eine Bestellung zu scannen oder direkt mittels Hardware-Taste scannen",
      "LABEL_KEINE_BESTELLUNGEN_VORHANDEN": "Es liegen derzeit keine offenen Bestellungen zu Ihrem Benutzer vor"
    },
    "ARTIKELAUSWAHL": {
      "TITEL_ERFASSTE_ARTIKEL": "ERFASSTE ARTIKEL",
      "LABEL_ABGESCHLOSSEN": "Abgeschlossen"
    },
    "PALETTENAUSWAHL": {
      "TITEL_VORHANDENE_PALETTEN": "VORHANDENE PALETTEN",
      "LABEL_KEINE_PALETTEN_VORHANDEN": "Es befinden sich aktuell keine Paletten in dieser Bewegung"
    },
    "ARTIKEL_HEADER": {
      "TITEL_ARTIKEL": "ARTIKEL",
      "TITEL_PALETTE": "PALETTE",
      "LABEL_GESAMT": "Ges.: "
    },
    "ARTIKELDATEN_EINGABE": {
      "TITEL_MENGE": "MENGE",
      "TITEL_GEWICHT": "GEWICHT ",
      "TITEL_MENGE_PRO": "(MENGE PRO",
      "TITEL_CHARGE": "CHARGE",
      "TITEL_MHD": "MHD",
      "LABEL_GUELTIGES_MHD_ANGEBEN": "Bitte ein gültiges MHD angeben!",
      "LABEL_GUELTIGE_CHARGE_ANGEBEN": "Bitte eine gültige Chargen-Bezeichnung angeben!",
      "LABEL_KEINE_PALETTEN_VORHANDEN": "(Neue Palette, da keine Paletten vorhanden sind)",
      "LABEL_GUELTIGES_GEWICHT_EINGEBEN": "Bitte ein gültiges Gewicht eingeben!",
      "DIALOG": {
        "TITEL_PALETTE_AENDERN": "Palettendaten ändern",
        "TITEL_MENGE_OFFEN_PALETTE": "MENGE OFFEN",
        "TITEL_GEWICHT_OFFEN_PALETTE": "GEWICHT OFFEN",
        "TITEL_KOMMISSIONIERUNG_ABBRECHEN": "Kommissionierungsauftrag abbrechen",
        "SUB_TITEL_KOMMISSIONIERUNG_ABBRECHEN": "Um Abzubrechen wählen Sie bitte einer dieser Möglichkeiten aus:"
      }
    },
    "EMBALLAGEN_ERFASSUNG": {
      "TITEL_EMBALLAGEN": "EMBALLAGEN",
      "LABEL_KEINE_EMBALLAGEN_VORHANDEN": "Es befinden sich aktuell keine Emballagen in dieser Bewegung"
    },
    "SORT_FILTER_CONFIG": {
      "LABEL_BESTELLUNG_ID": "Bestellung-ID",
      "LABEL_LIEFERANT_NUMMER": "Lieferanten-Nummer",
      "LABEL_LIEFERANT_BEZEICHNUNG": "Lieferanten-Bezeichnung",
      "LABEL_BELEGNUMMER": "Belegnummer",
      "LABEL_BELEGDATUM": "Belegdatum",
      "LABEL_BEWEGUNG_ID": "Bewegung-ID",
      "LABEL_ARTIKELNUMMER": "Artikelnummer",
      "LABEL_ARTIKELBEZEICHNUNG": "Artikelbezeichnung"
    },
    "WARENZUGANG_BUCHEN": {
      "TITEL_ALLE_ARTIKEL_ABGESCHLOSSEN": "Alle Artikel abgeschlossen",
      "LABEL_ALLE_ARTIKEL_ABGESCHLOSSEN": "Es wurden alle Artikel/Positionen abgeschlossen",
      "TITEL_LIEFERSCHEINDATUM": "LIEFERSCHEINDATUM",
      "TITEL_BEZUGSNUMMER": "Bezugsnummer",
      "TITEL_LIEFERSCHEINNUMMER": "LIEFERSCHEINNUMMER",
      "LABEL_GUELTIGE_LFNUMMER_ANGEBEN": "Bitte eine gültige Lieferscheinnummer angeben!",
      "LABEL_GUELTIGES_LIEFERSCHEINDATUM_ANGEBEN": "Bitte ein gültiges Lieferscheindatum angeben!",
      "SUBTITEL_WARENZUGANG_BUCHEN": "Warenzugang buchen",
      "QUESTION_ALLE_ARTIKEL_ABGESCHLOSSEN_WEITERLEITEN": "Es befinden sich keine offenen Artikel mehr in dieser Bewegung. Möchten Sie den Warenzugang abschließen?"
    }
  }
}

